<template>
  <div>
    <div
      v-if="show"
      tabindex="-1"
      class="overflow-y-auto overflow-x-hidden fixed top-1/3 right-0 left-0 z-50  h-modal "
    >
      <div class="relative p-4 w-full max-w-md h-full md:h-auto">
        <div class="relative bg-white rounded-lg shadow-lg dark:bg-gray-700">
          <button
            type="button"
            @click="$emit('no')"
            class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
            data-modal-toggle="popup-modal"
          >
            <img class="w-5 h-5" :src="`${$getState('appUrl')}/img/pwa/modal-close.svg`" />
            <span class="sr-only">Close modal</span>
          </button>
          <div class="p-6 text-center">
            <svg
              aria-hidden="true"
              class="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <h3
              class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400"
            >
              {{ content }}
            </h3>
            <div  class="text-center">
              <button
                v-if="btnYes"
                data-modal-toggle="popup-modal"
                type="button"
                @click="$emit('yes')"
                class="text-white bg-btn-bg  focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2"
                :class="clas"
              >
               {{ btnYes }} 
              </button>
              <button
                v-if="btnNo"  
                data-modal-toggle="popup-modal"
                type="button"
                @click="$emit('no')"
                class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              >
               {{ btnNo }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: 'Are you sure you want to delete this Location?'
    },
    btnYes: {
      type: String,
      default: "Yes, I'm sure" 
    },
    btnNo: {
      type: String,
      default: 'No, cancel' 
    },
    clas: {
      type: String,
      default: ''
    }
  },
  computed: {
    show() {
      return this.$getState("isConfirmModal");
    }
  },
  watch: {
    show (flag) {
      this.$setState('setLoader', flag ? 1 : 0)
    }
  }
};
</script>